import { BasicPricingTaxi } from '../../../../shared/types';
import React, { createContext, useContext, useState } from 'react';

type ContextType<S> = [S, React.Dispatch<React.SetStateAction<S>>] | null;

const initialState = null;
const PricingInfoContext = createContext<ContextType<BasicPricingTaxi>>(null);
PricingInfoContext.displayName = 'PricingInfoContext';

function useCurrentBasicPricingTaxi() {
    const context = useContext(PricingInfoContext);
    if (!context) {
        throw new Error(`useCurrentPricing must be used within a PricingInfoProvider`);
    }

    const [CurrentBasicPricingTaxi, setCurrentBasicPricingTaxi] = context;

    return {
        CurrentBasicPricingTaxi,
        setCurrentBasicPricingTaxi,
    };
}

function BasicPricingInfoProvider(props) {
    const pricing = useState(initialState);
    return <PricingInfoContext.Provider value={pricing} {...props} />;
}

export { BasicPricingInfoProvider, useCurrentBasicPricingTaxi };
